import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import WhatsNewStore from '../stores/whatsNewStore';

export const useWhatsNewStore = () => useContext<{
  whatsNewStore: WhatsNewStore
}>(StoreContext);
